import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../../../config/api";

export const fetchProfileData = createAsyncThunk(
    'setting/fetchProfile',
    async (_, { rejectWithValue }) => {
        try {
            let resp = await axiosInstance.get(`/user/profile`);
            if (resp?.data?.status == 200) {
                return resp?.data?.data?.user;
            } else {
                return rejectWithValue('Failed to fetch profile')
            }
        } catch (error) {
            return rejectWithValue(error.response?.data?.message || 'An error occurred')
        }
    }
)

export const fetchBadges = createAsyncThunk(
    'setting/fetchBadges',
    async (_, { rejectWithValue }) => {
        try {
            let resp = await axiosInstance.get('/user/badge');
            if (resp?.status == 200) {
                return resp?.data?.data?.badges
            }
            else {
                return rejectWithValue('Failed to fetch badges')
            }
        } catch (error) {
            return rejectWithValue(error?.response?.data?.message || 'An error occurred')
        }
    }
)

export const fetchAds = createAsyncThunk(
    'setting/fetchAds',
    async (payload, { rejectWithValue }) => {
        const { latitude, longitude } = payload;
        try {
            let resp = await axiosInstance.get(`/user/advertisement?latitude=${latitude}&longitude=${longitude}`);
            if (resp?.status == 200) {
                return resp?.data?.data?.advertisement
            }
            else {
                return rejectWithValue('Failed to fetch Ads')
            }
        } catch (error) {
            return rejectWithValue(error?.response?.data?.message || 'An error occurred')
        }
    }
)


export const fetchBlockUsers = createAsyncThunk(
    'setting/fetchBlockUsers',
    async (_, { rejectWithValue }) => {
        try {
            let resp = await axiosInstance.get('/user/blocked-users');
            if (resp?.status == 200) {
                return resp?.data?.data?.blockedUsers;
            } else {
                return rejectWithValue('Failed to fetch badges')
            }
        } catch (error) {
            console.log(error)
            return rejectWithValue(error?.response?.data?.message || 'An error occurred')
        }
    }
)


const initialState = {
    loading: false,
    profileData: [],
    allbadges: [],
    allAds: [],
    blockUsers: [],
    error: null
}

export const settingSlice = createSlice({
    name: 'setting',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(fetchProfileData.pending, (state) => {
            state.loading = true
            state.profileData = []
            state.error = null
        });
        builder.addCase(fetchProfileData.fulfilled, (state, action) => {
            state.loading = false
            state.profileData = action.payload;
            state.error = null
        });
        builder.addCase(fetchProfileData.rejected, (state, action) => {
            state.loading = false
            state.profileData = []
            state.error = action.payload
        });
        builder.addCase(fetchBadges.pending, (state) => {
            state.loading = true;
            state.allbadges = [];
            state.error = null
        });
        builder.addCase(fetchBadges.fulfilled, (state, action) => {
            state.loading = false;
            state.allbadges = action.payload;
            state.error = null
        });
        builder.addCase(fetchBadges.rejected, (state, action) => {
            state.loading = false;
            state.allbadges = [];
            state.error = action.payload
        });
        builder.addCase(fetchAds.pending, (state) => {
            state.loading = true;
            state.allAds = [];
            state.error = null
        });
        builder.addCase(fetchAds.fulfilled, (state, action) => {
            state.loading = false;
            state.allAds = action.payload;
            state.error = null
        });
        builder.addCase(fetchAds.rejected, (state, action) => {
            state.loading = false;
            state.allAds = [];
            state.error = action.payload
        });
        builder.addCase(fetchBlockUsers.pending, (state) => {
            state.loading = true;
            state.blockUsers = [];
            state.error = null
        });
        builder.addCase(fetchBlockUsers.fulfilled, (state, action) => {
            state.loading = false;
            state.blockUsers = action.payload;
            state.error = null
        });
        builder.addCase(fetchBlockUsers.rejected, (state, action) => {
            state.loading = false;
            state.blockUsers = [];
            state.error = action.payload
        })
    }
})

export default settingSlice.reducer